<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <div class="d-flex mb-2 justify-content-end align-items-start">
                    <!-- Title -->
                    <p class="flex-grow-1" v-if="baseRoute && baseRoute.titles"><b>{{ $t('routeIntro') }}</b> {{baseRoute.titles[currentLanguage.key]}}</p>
                    <!-- Language dropdown -->
                    <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                </div>
                <!-- Form -->
                <div class="row">
                    <!-- featuredImage -->
                    <div role="group" class="form-group col-12 col-md-6">
                    <label class=""> {{ $t('featuredImageMandatory') }}</label>
                        <GalleryPicker v-model="route.featuredImage" :ratioWidth="1" :ratioHeight="1" v-bind:class="{ 'is-invalid': genericValidator(route.featuredImage, attemptedSubmit) === false || errorValidator('FeaturedImage') === false }" :max="1"></GalleryPicker>
                    </div>
                    <!-- images -->
                    <div role="group" class="form-group col-12 col-md-6">
                    <label class=""> {{ $t('images') }}</label>
                        <GalleryPicker v-model="route.images" :ratioWidth="1" :ratioHeight="1" v-bind:class="{ 'is-invalid': errorValidator('Images') === false }" :max="0"></GalleryPicker>
                    </div>
                </div>
                <div class="d-flex flex-wrap">
                    <div class="d-flex flex-column col-12 col-lg-6">
                        <!-- Titles -->
                        <div role="group" class="form-group">
                        <label class=""> {{ $t('titleMandatory') }}</label>
                            <CInput class="m-0" type="text" v-model="route.titles[currentLanguage.key]" :invalid-feedback="errorOutput['Titles']" :is-valid="genericValidator(route.titles, attemptedSubmit) && errorValidator('Titles')"></CInput>
                        </div>
                        <!-- Taglines -->
                        <div role="group" class="form-group">
                        <label class=""> {{ $t('tagLineMandatory') }}</label>
                            <CInput class="m-0" type="text" v-model="route.tagLines[currentLanguage.key]" :invalid-feedback="errorOutput['TagLines']" :is-valid="genericValidator(route.tagLines, attemptedSubmit) && errorValidator('TagLines')"></CInput>
                        </div>
                        <!-- Contents -->
                        <div role="group" class="form-group">
                            <label class=""> {{ $t('contentsMandatory') }}</label>
                            <vue-editor v-model="route.contents[currentLanguage.key]" v-bind:class="{'is-invalid': genericValidator(route.contents[currentLanguage.key], attemptedSubmit) == false || errorValidator('Contents') }"></vue-editor>
                            <div v-if="errorOutput['Contents']" class="invalid-feedback">{{errorOutput['Contents']}}</div>
                        </div>
                    </div>
                    <div class="d-flex flex-column col-12 col-lg-6">
                        <!-- Categories -->
                        <div role="group" class="form-group">
                        <label class=""> {{ $t('categoriesMandatory') }}</label>
                            <OptionsDropdown v-model="route.categories" :options="categoriesOptions" :title="$t('categories')" :index="0" :is-valid="genericValidator(route.categories, attemptedSubmit) && errorValidator('Categories')" :invalid-feedback="errorOutput['Categories']"></OptionsDropdown>
                        </div>
                        <!-- Intros -->
                        <div role="group" class="form-group">
                        <label class=""> {{ $t('introsMandatory') }}</label>
                            <CInput class="m-0" type="text" v-model="route.intros[currentLanguage.key]" :invalid-feedback="errorOutput['Intros']" :is-valid="genericValidator(route.intros, attemptedSubmit) && errorValidator('Intros')"></CInput>
                        </div>
                        <!-- Pois -->
                        <div role="group" class="form-group">
                        <label class=""> {{ $t('poisMandatory') }}</label>
                            <OptionsDropdown v-model="route.pois" :options="poisType" :title="$t('pois')" :index="0" :is-valid="genericValidator(route.pois, attemptedSubmit) && errorValidator('Pois')" :invalid-feedback="errorOutput['Pois']"></OptionsDropdown>
                        </div>
                        <!-- Model3d -->
                        <div role="group" class="form-group">
                            <FilesPicker v-model="route.model3d" :max="1" :title="$t('model3dMandatory')" mime="obj" accept=".obj" v-bind:class="{'is-invalid': genericValidator(route.model3d, attemptedSubmit) === false || errorValidator('Model3d') === false}" :invalidFeedback="errorOutput['Model3d']"></FilesPicker>
                        </div>
                        <!-- files (not required) -->
                        <div role="group" class="form-group">
                            <FilesPicker v-model="route.files" :title="$t('Files')" v-bind:class="{ 'is-invalid': errorValidator('Files') === false }" :invalidFeedback="errorOutput['Files']"></FilesPicker>
                        </div>
                        <!-- publishDate -->
                        <div role="group" class="form-group">
                            <label class=""> {{ $t('publishDate') }}</label>
                            <datepicker class="form-control" v-model="route.publishDate" placeholder="DD-MM-YYYY" :disabled-dates="disabledDates"></datepicker>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center col-12 p-0 gap-2 flex-wrap">
                    <label> {{ $t('options') }}</label>
                    <button type="button" class="btn btn-secondary mx-2" @click="addOption">{{ $t('addOption') }}</button>
                    <button type="button" class="btn btn-secondary" @click="removeCurrentOption">{{ $t('removeOption') }}</button>
                </div>
                <CTabs class="col-12 p-0 mt-3" v-if="route.options && route.options.length" variant="pills" :activeTab="currentOption">
                    <CTab v-for="(route, index) in route.options" :key="index" :title="$t('route') + ' ' + (index + 1)">
                        <div class="d-flex flex-column mt-2">
                            <!-- Options.Names -->
                            <div role="group" class="form-group">
                                <label class=""> {{ $t('optionsNameMandatory') }}</label>
                                <CInput class="m-0" type="text" v-model="route.names[currentLanguage.key]" :invalid-feedback="errorOutput.Routes[index].Names" :is-valid="genericValidator(route.names, attemptedSubmit) && errorValidator(`Routes[${index}].Names`)"></CInput>
                            </div>
                            <!-- Options.Times -->
                            <div role="group" class="form-group">
                                <label class=""> {{ $t('optionsTimeMandatory') }}</label>
                                <CInput class="m-0" type="text" v-model="route.times[currentLanguage.key]" :invalid-feedback="errorOutput.Routes[index].Times" :is-valid="genericValidator(route.times, attemptedSubmit) && errorValidator(`Routes[${index}].Times`)"></CInput>
                            </div>
                            <!-- Options.Distance -->
                            <div role="group" class="form-group">
                                <label class=""> {{ $t('optionsDistanceMandatory') }}</label>
                                <CInput class="m-0" type="number" v-model="route.distance" :invalid-feedback="errorOutput.Routes[index].Distance" :is-valid="genericValidator(route.distance, attemptedSubmit) && errorValidator(`Routes[${index}].Distance`)"></CInput>
                            </div>
                            <!-- Options.Typology -->
                            <div role="group" class="form-group">
                                <label class=""> {{ $t('optionsTypologyMandatory') }}</label>
                                <SingleOptionDropdown v-model="route.topology" :options="topologyType" :title="$t('typologyMandatory')" :index="0" :is-valid="genericValidator(route.topology, attemptedSubmit) && errorValidator('TypologyMandatory')" :invalid-feedback="errorOutput['TypologyMandatory']"></SingleOptionDropdown>
                            </div>
                            <!-- Options.Unevenness -->
                            <div role="group" class="form-group">
                                <label class=""> {{ $t('optionsUnevennessMandatory') }}</label>
                                <CInput class="m-0" type="number" v-model="route.unevenness" :invalid-feedback="errorOutput.Routes[index].Unevenness" :is-valid="genericValidator(route.unevenness, attemptedSubmit) && errorValidator(`Routes[${index}].Unevenness`)"></CInput>
                            </div>
                            <!-- Options.Difficulty -->
                            <div role="group" class="form-group">
                                <label class=""> {{ $t('optionsDifficultyMandatory') }}</label>
                                <SingleOptionDropdown v-model="route.difficulty" :options="difficultyType" :title="$t('typologyMandatory')" :index="0" :is-valid="genericValidator(route.difficulty, attemptedSubmit) && errorValidator('Difficulty')" :invalid-feedback="errorOutput['Difficulty']"></SingleOptionDropdown>
                            </div>
                            <!-- Options.Duration -->
                            <div role="group" class="form-group">
                                <label class=""> {{ $t('optionsDurationMandatory') }}</label>
                                <CInput class="m-0" type="time" step="1" v-model="route.duration" :invalid-feedback="errorOutput.Routes[index].Duration" :is-valid="genericValidator(route.duration, attemptedSubmit) && errorValidator(`Routes[${index}].Duration`)"></CInput>
                            </div>
                        </div>
                    </CTab>
                </CTabs>
                <!-- Action button + submitting -->  
                <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                <CButton v-else type="button" class="btn btn-primary align-self-end" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                <!-- Loading -->
                <FormLoading v-if="loading"></FormLoading>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import { mapState, mapActions  } from 'vuex'
import router from '@/router/index';
import { deepClone } from "@/helpers/utils.js";
import { CONSTANTS } from '@/helpers/consts';
import { genericValidator, errorValidator } from "@/helpers/utils.js";
import Route from "@/classes/Route";
import RouteOptions from "@/classes/RouteOptions";
import LanguageDropdown from '@/controls/LanguageDropdown.vue'
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import OptionsDropdown from '@/controls/OptionsDropdown.vue'
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'
import GalleryPicker from '@/controls/GalleryPicker.vue'
import FilesPicker from '@/controls/FilesPicker.vue'
import FormLoading from '@/controls/FormLoading.vue'
import { VueEditor } from "vue2-editor";
import InputGetList from "@/classes/InputGetList";
import { API_HELPER } from "@/helpers/api.js";
import Datepicker from 'vuejs-datepicker';

  export default {
        components: { LanguageDropdown, ConfirmationPopUp, GalleryPicker, OptionsDropdown, FormLoading, FilesPicker, VueEditor, InputGetList, SingleOptionDropdown, Datepicker },
    props:{    
        baseRoute:
        {
            type: Object,
            default: null,
        },
        baseName:
        {
            type: String,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            attemptedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            route: new Route({}, {}, {}, {}, [], [], [], [], []),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
            currentOption: 0,
            selectType: [],
            disabledDates: {
                to: new Date(new Date().setDate(new Date().getDate()-1))
            },
            poisType: [ {label: this.$t("whatToVisit"), key: 1}, {label: this.$t("whereToEat"), key: 2}, {label: this.$t("whereToStay"), key: 3}],
            topologyType: [ {label: this.$t("circular"), key: "Circular"}, {label: this.$t("linear"), key: "Linear"}],
            difficultyType: [ {label: this.$t("easy"), key: "Easy"}, {label: this.$t("intermediate"), key: "Intermediate"}, {label: this.$t("hard"), key: "Hard"}],
        }
    },
    mounted: function()
    {
        this.resetRoute();
        this.getRouteCategories();
    },
    computed:
    {
        ...mapState('routes', ['putRouteOutput']),
        ...mapState('routes', ['postRouteOutput']),
        ...mapState('categories', ['getCategoriesOutput']),
        ...mapState('pois', ['getPoisOutput']),
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = this.alertOutput && Array.isArray(this.alertOutput) ? this.alertOutput : [];

            // Validate Options
            result.Routes = [];
            const self = this;

            this.route.options.forEach(function(option){
                var error = {};

                for (const [key, value] of Object.entries(option.names)) {
                    if(!value)
                    {
                        error['Names'] = self.$i18n.t("validateBothTranslations");
                        break;
                    }
                }

                for (const [key, value] of Object.entries(option.times)) {
                    if(!value)
                    {
                        error['Times'] = self.$i18n.t("validateBothTranslations");
                        break;
                    }
                }
               
                result.Routes.push(error);
            });

            return result;
        },
        name: function () {
            return this.baseRoute || this.baseName ? (this.baseRoute ? this.baseRoute.name : this.baseName) : null;
        },
        categoriesInfo: function() {
            return this.getCategoriesOutput && this.getCategoriesOutput.data ? this.getCategoriesOutput.data : [];
        },
        categoriesOptions: function()
        {
            var result = [];

            if(this.categoriesInfo)
            {
                this.categoriesInfo.forEach(category => 
                {
                    result.push({key: category.id, label: category.name });
                });
            }

            return result;
        },   
        poisOptions: function()
        {
            var result = [];

            if(this.poisInfo)
            {
                this.poisInfo.forEach(category => 
                {
                    result.push({key: category.id, label: category.name });
                });
            }

            return result;
        },   
    },
    methods:{
        ...mapActions('categories', ['getCategories']),
        genericValidator,
        errorValidator,
        resetRoute(){
            if(!this.baseRoute)
            {   
                var titles = {}
                var tagLines = {}
                var contents = {}
                var intros = {}
                
                CONSTANTS.supportedLanguages.forEach(language => { titles[language.key]= "", tagLines[language.key]= "", contents[language.key]= "", intros[language.key]= ""});
                this.route = new Route(titles, tagLines, contents, intros, [], [], [], [], [], []);
            }
            else
            {
                this.route = deepClone(new Route, this.baseRoute);   
                // featuredImage
                this.route.featuredImage = {url: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.route.featuredImagePath]), path: this.route.featuredImagePath};

                // Images
                var images = [];
                this.route.imagesPath.forEach(function(file)
                {
                    images.push({url: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, file]), path: file});
                });
                this.route.images = images;

                //categories
                this.route.categories = this.route.categories.map(category => category.id)
                
                // model3dPath
                this.route.model3d = {path: this.route.model3dPath};
                // console.log(this.route.model3d)

                // Files
                let files = [];
                this.route.filesPath.forEach(function(file)
                {
                    files.push({path: file});
                });
                this.route.files = files;
            }
        },
        addOption()
        {
            var names = {};
            var times = {};

            CONSTANTS.supportedLanguages.forEach(language => { names[language.key] = ""; times[language.key] = "" });

            this.route.options.push(new RouteOptions(names, times));
        },
        removeCurrentOption()
        {
            this.route.options.splice(this.currentOption, 1);
        },
        submitClicked(){
            this.attemptedSubmit = true;

            // Emit event
            if(this.route.isValid())
            {
                this.submitting = true;
                
                // Use a clone to modify paths
                var inputRoute = deepClone(new Route, this.route);  
                if (typeof inputRoute.model3d === 'string' || inputRoute.model3d instanceof String)
                {
                    inputRoute.model3d = { path: inputRoute.model3d };
                }

                this.$emit('submit-requested', inputRoute);
            }
        },
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            router.push({ name: 'Routes'});
        },
        onProcessTask: function(val)
        {
            if(val != null)
            {
                if(val)
                {
                    this.showConfirmationPopup = true;
                }

                this.submitting = false;
            }
        },
        getRouteCategories(){
            const itemsPerPage = 999;
            const currentPage = 1;
            const searchText = null;
            const sorter = 1; // ASC
            const propertyName = "name";

            var input = new InputGetList(itemsPerPage, currentPage, searchText, sorter, propertyName);
            input.type = 5; // type -> Route

            this.getCategories(input);         
        }
    },
    watch:
    {
        putRouteOutput: function(val)
        {
            this.onProcessTask(val);
        },
        postRouteOutput: function(val)
        {
            this.onProcessTask(val);
        },
        baseRoute: function()
        {
            this.resetRoute();
        },
        alertOutput: function()
        {
            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
  }
</script> 
 
<style scoped>

@media only screen and (max-width: 767px) {
    .main-content {
        flex-direction: column;
    }
}

/deep/.quillWrapper.is-invalid .ql-snow.ql-toolbar,
/deep/.quillWrapper.is-invalid .ql-snow.ql-container
{
    border-color: #e55353;
}
>>>.vdp-datepicker input{
    border: none!important;
}
</style> 